import React, { useEffect, useMemo } from 'react';

import { AdsContext } from '@/core/lib/ads/ads.context';
import Store from '@/core/lib/new-architecture/store';
import { useRouterContext } from '@/core/lib/router/router.context';

const OPTIDIGITAL_LOCAL_STORAGE_VALUE = '61ff0363-80ed-42b8-8ec8-d24ea11c294a';
const OTIDIGITAL_LOCAL_STORAGE_KEY = 'opti';

const OptiDigital: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data: current } = Store.current.useCurrent();
  const { reload } = useRouterContext();

  useEffect(
    function updateLocalStorageForOptiDigital() {
      const removeOptiFromLocalStorage = () => {
        localStorage.removeItem(OTIDIGITAL_LOCAL_STORAGE_KEY);
      };

      if (current) {
        const opti = localStorage.getItem(OTIDIGITAL_LOCAL_STORAGE_KEY);

        if (current.displayAds()) {
          if (opti) {
            removeOptiFromLocalStorage();
            reload?.();
          }
        } else {
          if (!opti) {
            localStorage.setItem(OTIDIGITAL_LOCAL_STORAGE_KEY, OPTIDIGITAL_LOCAL_STORAGE_VALUE);
            reload?.();
          }
        }
      }

      window.addEventListener('donnons-logout', removeOptiFromLocalStorage);

      return () => {
        window.removeEventListener('donnons-logout', removeOptiFromLocalStorage);
      };
    },
    [current],
  );

  const value = useMemo(
    () => ({
      Ad: () => null,
      isLoaded: true,
      Interstitial: () => null,
      showReward: () => {},
    }),
    [],
  );

  return <AdsContext.Provider value={value}>{children}</AdsContext.Provider>;
};

export default OptiDigital;
